<template>
    <div class="my-account-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Mon compte</div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">Informations sur votre compte :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Nom Auto-école</div>
                    <div class="form__item__input-wrapper">
<!--                        <input type="text" v-model="driving_school.name" class="input_n"/>-->
                        <div>{{driving_school.name}}</div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Email</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="driving_school.email" class="input_n"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Adresse</div>
                    <div class="form__item__input-wrapper">
<!--                        <input type="text" v-model="driving_school.address" class="input_n"/>-->
                        <div>{{driving_school.address}}</div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Ville</div>
                    <div class="form__item__input-wrapper">
<!--                        <input type="text" v-model="driving_school.city" class="input_n"/>-->
                        <div>{{driving_school.city}}</div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Code postal</div>
                    <div class="form__item__input-wrapper">
<!--                        <input type="text" v-model="driving_school.zip" class="input_n"/>-->
                        <div>{{driving_school.zip}}</div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="update" value="Envoyer"
                               class="form_bt form__item__submit__button"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form_ttl">Si vous voulez modifier votre mot de passe:</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre
                        mot de passe actuel
                    </div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="old_password" class="input_n" autocomplete="new-password"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre
                        nouveau mot de passe
                    </div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="password" class="input_n"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Confirmez votre
                        nouveau mot de passe
                    </div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="password_confirmation" class="input_n"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="saveNewPassword" value="Envoyer"
                               class="form_bt form__item__submit__button"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {validationMixin} from 'vuelidate'
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: 'MyAccount',
        data() {
            return {
                driving_school: {
                    name: null,
                    email: null,
                    address: null,
                    city: null,
                    zip: null,
                },
                old_password: null,
                password: null,
                password_confirmation: null,
                iban: null,
            }
        },
        mixins: [
            validationMixin
        ],
        computed: {
            user() {
                return this.$store.state.userInfo;
            }
        },
        watch: {
            '$store.getters.getAuthUserInfo': function (user) {
                this.parseInfo(user);
            }
        },
        methods: {
            parseInfo(user) {
                this.driving_school.name = user.driving_school.name;
                this.driving_school.email = user.email;
                this.driving_school.address = user.driving_school.address;
                this.driving_school.city = user.driving_school.city;
                this.driving_school.zip = user.driving_school.zip;
            },
            update() {
                if (!this.$v.$invalid) {
                    let url = `driving_schools/${this.user.driving_school.id}`,
                        data= this.driving_school;

                    this.apiUpdate(url, data)
                        .then(response => {
                            let updatedUser = response.data.user;

                            //flip data for correct user info updating
                            updatedUser.driving_school = response.data;
                            updatedUser.driving_school_id = response.data.id;
                            this.$store.dispatch('updateUserInfo', updatedUser);

                            this.showSuccessNotification('Les informations sur votre compte ont bien étés enregistrées.');
                        })
                        .catch(error => this.showErrorNotification(error));
                } else {
                    this.showWarningNotification('Please check up that all fields are correct.');
                }
            },
            saveNewPassword() {
                let url = this.user.id + '/change-password';
                let data = {
                    old_password: this.old_password,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                };

                this.apiUpdate(url, data).then(response => {
                    this.showSuccessNotification('Votre mot de passe a bien été mis à jour');
                    this.clearPasswordForm()
                }).catch(error => {
                    this.showErrorNotification(error);
                });
            },
            clearPasswordForm() {
                this.old_password = '';
                this.password = '';
                this.password_confirmation = '';
            }
        },
        mounted() {
            if (this.user) {
                this.parseInfo(this.user);
            }
        },
        validations: {
            driving_school: {
                name: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                address: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/DrivingSchool/Profile/DrivingSchoolMyAccount.vue